/** Suggested next step for a newly chosen type; existing plans remain authoritative. */
export function defaultNextActionKind(type:string){
 return type==="followup"?"remind":type==="decision"?"decide":"do";
}
export const taskTypeHelp:Record<string,string>={
 task:"Etwas, das du selbst erledigen oder organisieren möchtest.",
 followup:"Eine Zusage oder Rückmeldung, bei der du nachfassen möchtest. Trage die verantwortliche Person ein.",
 decision:"Eine offene Entscheidung. Halte Grundlagen in der Beschreibung und das Ergebnis später im Verlauf fest.",
 idea:"Ein Gedanke, den du später weiterentwickeln kannst.",
 container:"Ein übergeordneter Vorgang, der mehrere Unteraufgaben bündelt."
};
